import {MessageLogger} from "./MessageLogger";
import {TakipAcStatusEnum} from "./parser/TakipAcStatusEnum";
import app from "@/main";
import {Mixins} from "./Mixins";
import {EvrakGonderCevap} from "../uyap/DosyaAcilisEvrakGonder";
import TakipSenkronize from "./TakipSenkronize";
import UyapTakipTalebiContent from "./UyapTakipTalebiContent";

export default class TakipAcInjectable extends MessageLogger {
    status: TakipAcStatusEnum = TakipAcStatusEnum.QUERY_PENDING;
    imzasizUdf !: Blob;
    imzaliUdf !: Blob;
    vekalet !: Blob;
    takipAcilisEvraklariResponse!: EvrakGonderCevap;

    takipBilgileri = {
        dosyaEsasNo: "",
        icraDairesi: ""
    };
    dayanaklar: Blob[] = []

    constructor() {
        super();
    }

    setStatus(status: TakipAcStatusEnum) {
        this.status = status;
    }

    mukerrerDosyaKontrol(hash: string, type: "xml" | "uyap"): Promise<any> {
        return new Promise(async (resolve, reject) => {
            //        //this.hashObj, this.tarafList, this.toplamTakibeEsasMiktar
            try {
                let isMukerrer: {
                    success: boolean,
                    message: string,
                    data: {
                        dosya: any | null
                    }
                } = await app.$http.post('/api/v1/hash-kontrol/' + type, {
                    hash: hash,
                    type: type,
                });
                if (isMukerrer.success == true)
                    return resolve({});
                else
                    return reject({message: ('Seçili takip daha önce tevzi almıştır. Hash: #' + hash), dosya: isMukerrer.data.dosya});
            } catch (e) {
                return reject({message: ("Hash sorgulanamadı. " + e.message)});
            }
        })
    }


    mukerrerDosyaKontrolFromTakipTalebi(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                let parsedContent: any = await TakipSenkronize.parseContentXml(this.imzasizUdf);
                console.log("TakipSenkronize.parseContentXml",parsedContent);
                let uyapTakipTalebiContent = UyapTakipTalebiContent.parse(parsedContent);
                console.log("UyapTakipTalebiContent.parse", uyapTakipTalebiContent);
                let isMukerrer: {
                    success: boolean,
                    message: string,
                    data: {
                        dosya: any | null
                    }
                } = await app.$http.post('/api/v1/hash-kontrol/uyap', {
                    hash: uyapTakipTalebiContent.hash,
                    type: 'uyap',
                });
                if (isMukerrer.success == true)
                    return resolve({});
                else
                    return reject({message: ('Seçili takip daha önce tevzi almıştır. Hash: #' + uyapTakipTalebiContent.hash), dosya: isMukerrer.data.dosya});
            } catch (e) {
                console.error("mukerrerDosyaKontrolFromTakipTalebi", e);
                return resolve({});
                return reject({message: ("Hash sorgulanamadı. " + e.message)});
            }
        })
    }

    hashSil(hash: string, type: "xml" | "uyap"): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                await app.$http.delete('/api/v1/hash-kontrol/' + type + '/' + hash);
                return resolve({message: 'Hash başarıyla silindi.'});
            } catch (e) {
                return reject({message: 'Hash silinirken hata oluştu: ' + e.message});
            }
        })
    }


    async setTakipBilgileriToIcraPro(dosyaBilgileri: any): Promise<void> {
        let dosyaBelirleyici = dosyaBilgileri.dosyaBelirleyici;
        if(dosyaBilgileri.isIcraProXml()){
            return app.$imza.icrapro80VeriAktar(this.takipBilgileri.dosyaEsasNo,this.takipBilgileri.icraDairesi,dosyaBelirleyici.id,dosyaBelirleyici.klasor);
        }
        else if(dosyaBilgileri.isIcraProWebXml()){
            //icradairesi search-
            let icraDairesiId = null;
            try{
                if(dosyaBelirleyici?.id > 0){
                    let icraDairesi = await app.$http.post("/api/v1/icra-dairesi/ara",{icra_dairesi_isim: this.takipBilgileri.icraDairesi});
                    icraDairesiId = icraDairesi.data.id;
                    return app.$http.patch("/api/v1/takip/"+dosyaBelirleyici.id+"/dosya-esas-no-icra-dairesi",{ icra_dairesi_id: icraDairesiId,dosya_esas_no: this.takipBilgileri.dosyaEsasNo})
                }
            }catch (e) {
                console.log("e",e);
                // İcra dairesi bulunamadı, null olarak devam et
                return;
            }
        }

        return;
    }

    async getImzasizUdfFromUyap(dosyaId: string): Promise<void> {
        let takibTalebi = await app.$uyap.TakipTalebiIndir(dosyaId)
            .run({
                download: true,
                filename: "takip_talebi.udf"
            });
        this.imzasizUdf = takibTalebi.file;
        // eslint-disable-next-line no-console
        console.log("this.imzasizUdf", this.imzasizUdf);
    }

    async mtsGetImzasizUdfFromUyap(dosyaId: string): Promise<void> {
        let takibTalebi = await app.$uyap.MtsTakipTalebiIndir()
            .run({
                dosyaId: dosyaId
            });
        this.imzasizUdf = takibTalebi.file;
        // eslint-disable-next-line no-console
        console.log("this.imzasizUdf", this.imzasizUdf);
    }

    setTakipBilgileriFromTakipAcilisEvraklariResponse(): Promise<any> {
        try {
            let div = document.createElement("div");
            // eslint-disable-next-line no-console
            console.log("takipAcilisEvraklariResponse",this.takipAcilisEvraklariResponse);
            div.innerHTML = this.takipAcilisEvraklariResponse.message;
            let nodeList = div.querySelectorAll("strong");
            if (nodeList.length == 0)
                return Promise.reject({message: "Takip açılış yapılamadı !"});
            this.takipBilgileri.icraDairesi = nodeList[0].innerHTML;
            this.takipBilgileri.dosyaEsasNo = nodeList[1].innerHTML;
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    }



    async takipAcilisEvraklariniGonder(tevziDosyaId: string,isMts: boolean = false): Promise<EvrakGonderCevap> {
        try {
            await this.dokumanImzala();
            let formData: any;
            if(isMts)
                formData = this.getDosyaAcilisEvraklarFormDataForMts(tevziDosyaId);
            else
                formData = this.getDosyaAcilisEvraklarFormData(tevziDosyaId);
            let evraklarResult = await app.$uyap.DosyaAcilisEvrakGonder().run(
                {
                    formData: true,
                    data: formData
                })
            this.addMessage('success', "Dosya açılış evrakları gönderildi.");
            this.takipAcilisEvraklariResponse = evraklarResult;
            return Promise.resolve(evraklarResult);
        } catch (e) {
            this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
            this.addMessage('error', e.message);
            return Promise.reject(e)
        }
    }

    getDosyaAcilisEvraklarFormDataForMts(tevziDosyaId: any): FormData {
        //acilisda mandatory true gidiyor ///
        let gonderilecekEvraklar = {
            "tur": "",
            "turAciklama": "",
            "dosyaId": tevziDosyaId,
            "esasNo": "",
            "data": [
                {
                    "tur": "ICR_TAKIP_TLP",
                    "turAciklama": "Takip Talebi",
                    "aciklama": "Takip Talebi",
                    "evrak": this.imzaliUdf,
                    "dosyaEkEvrak": []
                },
                {
                    "tur": "CZM_VEKALETNAME",
                    "turAciklama": "Vekaletname",
                    "aciklama": "Vekaletname",
                    "evrak": this.getVekaletBlob(),
                    "dosyaEkEvrak": []
                }]
        };
        this.getDayanaklarBlobArray().forEach((dayanakBlob) => {
            gonderilecekEvraklar.data.push(
                {
                    "tur": "MTS_TAKIBIN_DAYANAGI",
                    "turAciklama": "Takibin Dayanağı",
                    "aciklama": "Takibin Dayanağı",
                    "evrak": dayanakBlob,
                    "dosyaEkEvrak": []
                }
            );
        })
        // eslint-disable-next-line no-console
        console.log("gonderilecekEvraklar", gonderilecekEvraklar);
        let evraklar: any[] = gonderilecekEvraklar.data;
        let items: any[] = [];
        let anaEvrakCounter = 1;
        let counter = 1;
        let form = new FormData();
        let defaultTurlist = [
            ".udf",
            ".pdf",
            ".jpg",
            ".jpeg",
            ".png",
            ".tif",
            ".tiff",
            ".UDF",
            ".PDF",
            ".JPG",
            ".JPEG",
            ".PNG",
            ".TIF",
            ".TIFF"
        ];
        let takipTalebiTurList = [
            ".jpg",
            ".udf",
            ".JPG",
            ".UDF"
        ];
        let turList = [];
        let ekEvrakTurList = [];
        evraklar.forEach((evrak, i) => {
            let evrakName = "evrak_" + anaEvrakCounter + ".udf";
            if (typeof evrak.evrak.name != "undefined") {
                evrakName = evrak.evrak.name;
            } else {
                let fileExt = Mixins.getFileExtension(evrak.evrak.type);
                evrakName = "dosya_" + i + "." + fileExt;
            }
            if (evrak.tur == "ICR_TAKIP_TLP") {
                turList = [".udf",".UDF"];
                ekEvrakTurList = takipTalebiTurList;
                evrak.aciklama = "";
            } else {
                turList = defaultTurlist;
                ekEvrakTurList = defaultTurlist;
            }
            items.push({
                id: (new Date()).getTime(),
                evrakTuruOptionDVO: {
                    tur: evrak.tur,
                    label: evrak.turAciklama,
                    mandatory: true,
                    max: 1,
                    ekEvrakMax: 5,
                    acceptTypeList: turList,
                    ekEvrakAcceptTypeList: ekEvrakTurList,
                },
                tur: evrak.tur,
                turAciklama: evrak.turAciklama,
                mandatory: true,
                file: {},
                path: "C:\\fakepath\\" + evrakName,
                kullaniciEvrakAciklama: evrak.aciklama,
                parentId: -1,
                isVekalet: false,
                isVekaletBilgiFormu: false,
                fileId: anaEvrakCounter
            });
            // eslint-disable-next-line no-console
            console.log("EKLENEN EVRAK ", evrak.evrak);
            form.append("file_" + anaEvrakCounter, evrak.evrak, evrakName);
            // eslint-disable-next-line no-console
            console.log("F append => ", "file_" + anaEvrakCounter, evrak.evrak, evrakName);
            counter++;
            anaEvrakCounter = counter;
        })
        form.append("items", JSON.stringify(items));
        form.append("dosyaId", tevziDosyaId);
        return form;
    }

    getDosyaAcilisEvraklarFormData(tevziDosyaId: any): FormData {
        //acilisda mandatory true gidiyor ///

        let gonderilecekEvraklar = {
            "tur": "",
            "turAciklama": "",
            "dosyaId": tevziDosyaId,
            "esasNo": "",
            "data": [
                {
                    "tur": "ICR_TAKIP_TLP",
                    "turAciklama": "Takip Talebi",
                    "aciklama": "Takip Talebi",
                    "evrak": this.imzaliUdf,
                    "dosyaEkEvrak": []
                },
                {
                    "tur": "CZM_VEKALETNAME",
                    "turAciklama": "Vekaletname",
                    "aciklama": "Vekaletname",
                    "evrak": this.getVekaletBlob(),
                    "dosyaEkEvrak": []
                }]
        };
        this.getDayanaklarBlobArray().forEach((dayanakBlob) => {
            gonderilecekEvraklar.data.push(
                {
                    "tur": "MTS_TAKIBIN_DAYANAGI",
                    "turAciklama": "Takibin Dayanağı",
                    "aciklama": "Takibin Dayanağı",
                    "evrak": dayanakBlob,
                    "dosyaEkEvrak": []
                }
            );
        })
        // eslint-disable-next-line no-console
        console.log("gonderilecekEvraklar", gonderilecekEvraklar);
        let evraklar: any[] = gonderilecekEvraklar.data;
        let items: any[] = [];
        let anaEvrakCounter = 1;
        let counter = 1;
        let form = new FormData();
        let defaultTurlist = ["udf", "pdf", "jpg", "png", "jpeg", "tif", "tiff", "JPG", "JPEG", "PNG", "PDF", "TIF", "TIFF"];
        let turList = [];
        evraklar.forEach((evrak, i) => {
            let evrakName = "evrak_" + anaEvrakCounter + ".udf";
            if (typeof evrak.evrak.name != "undefined") {
                evrakName = evrak.evrak.name;
            } else {
                let fileExt = Mixins.getFileExtension(evrak.evrak.type);
                evrakName = "dosya_" + i + "." + fileExt;
            }
            if (evrak.tur == "ICR_TAKIP_TLP") {
                turList = ["udf"];
            } else {
                turList = defaultTurlist;
            }
            items.push({
                id: i + 1,//i 0 oldugu icin +1 = id 1 den basliyor
                evrakTuruOptionDVO: {
                    tur: evrak.tur,
                    id: evrak.tur,
                    label: evrak.turAciklama,
                    mandatory: true,
                    max: 1,
                    ekEvrakMax: 5,
                    acceptTypeList: {
                        turList: turList
                    }
                },
                tur: evrak.tur,
                turAciklama: evrak.turAciklama,
                mandatory: true,
                file: {},
                path: "C:\\fakepath\\" + evrakName,
                kullaniciEvrakAciklama: evrak.aciklama,
                parentId: -1,//-1
                fileId: anaEvrakCounter
            });
            // eslint-disable-next-line no-console
            console.log("EKLENEN EVRAK ", evrak.evrak);
            form.append("file_" + anaEvrakCounter, evrak.evrak, evrakName);
            // eslint-disable-next-line no-console
            console.log("F append => ", "file_" + anaEvrakCounter, evrak.evrak, evrakName);
            counter++;
            evrak.dosyaEkEvrak.forEach((dosyaEkEvrak: any) => {
                items.push({
                    id: i + 1,//i 0 oldugu icin +1 = id 1 den basliyor
                    evrakTuruOptionDVO: {
                        tur: evrak.tur,
                        id: evrak.tur,
                        label: evrak.turAciklama,
                        mandatory: false,
                        max: 1,
                        ekEvrakMax: 5,
                        acceptTypeList: {
                            turList: ["udf"]
                        }
                    },
                    tur: evrak.tur,
                    turAciklama: evrak.turAciklama,
                    mandatory: false,
                    file: {},
                    path: "C:\\fakepath\\" + dosyaEkEvrak.name,
                    kullaniciEvrakAciklama: "Ek " + counter,
                    parentId: anaEvrakCounter,
                    fileId: counter
                });

                form.append("file_" + counter, dosyaEkEvrak, dosyaEkEvrak.name);
                // eslint-disable-next-line no-console
                console.log("append => ", "file_" + counter, dosyaEkEvrak, dosyaEkEvrak.name);
                counter++;
            })
            anaEvrakCounter = counter;
        })
        form.append("items", JSON.stringify(items));
        form.append("dosyaId", tevziDosyaId);
        return form;
    }

    getDayanaklarBlobArray(): Blob[] {
        return this.dayanaklar;
    }

    getVekaletBlob() {
        return this.vekalet;
        /*
        if (typeof this.par.vekalet.data == "string") {
            this.vekalet.data = this.vekalet.data.replace('<!--[CDATA[', '').replace(']]-->', '');
        }
        let vekaletB64 = this.vekalet.data;
        //vekalet base64 olarak geldiyse
        if (typeof vekaletB64 == "string" && vekaletB64.indexOf(',') > 0) {
            vekaletB64 = this.vekalet.data.split(',')[1];
        }
        // eslint-disable-next-line no-console
        console.log("this.vekalet",this.vekalet);
        console.log("this.imzaliUdf",this.imzaliUdf);
        this.vekaletBlob = Mixins.b64toBlob(vekaletB64, this.vekalet.mimeType);
        //application/octet-stream
        console.log("VEKALET BLOB",this.vekaletBlob);
         */
    }

    convertToISOFormat(dateStr: string) {
        // dateStr -> 09/05/2024 10:43:06
        const parts = dateStr.split(" "); // Boşluklardan böl
        const dateParts = parts[0].split("/"); // Tarihi '/' işaretlerinden böl
        const timeParts = parts[1].split(":"); // Saati ':' işaretlerinden böl

        const isoDateStr = `${dateParts[2]}-${dateParts[1]}-${
            dateParts[0]
        }T${timeParts.join(":")}`;
        return isoDateStr;
    }

    async dokumanImzala(): Promise<void> {
        //app.$imza.setSimulator();
        if(app.$store.getters.isEicraproDevMode){
            this.imzaliUdf = new Blob();
        }else{

            this.addMessage("info", "Takip talebi imzalanıyor.")

            //todo imzasiz udf bossa indir.

            let imzaliUdf = await app.$imza.dokumanImzala(this.imzasizUdf);
            this.addMessage('success', 'Takip talebi imzalandı')
            let imzaliUdfBlob: Blob = app.$uyapHelper.base64toBlob(imzaliUdf, "application/octet-stream");
            console.log("Dokuman Imzalandi", imzaliUdfBlob);
            this.imzaliUdf = imzaliUdfBlob;

        }

    }
}

